/**
 * delay of a double click, in ms
 */
export const DB_CLICK_DELAY = 250;

/**
 * delay after which the event is reset
 */
export const RESET_CLICK_DELAY = 6666;
